import { getFullAssetPath } from 'obt-common';
import { useAppBranding } from 'src/components/AppBrandingProvider/AppBrandingProvider';
import { useTranslation } from 'react-i18next';
import { illustration_container } from './LoginIllustration.styles';

export const LoginIllustration = ({ isAppIdLogin = false }: { isAppIdLogin?: boolean }) => {
  const { authPageConfig, companyName } = useAppBranding();
  const { t: tt } = useTranslation('WEB');
  // eslint-disable-next-line no-nested-ternary
  const illustrationImageUrl = isAppIdLogin
    ? companyName === 'Spotnana'
      ? getFullAssetPath('/v1-assets/illustrations/traveler-woman', 'svg')
      : ''
    : authPageConfig.illustrations;

  // if there is no image to be shown, render nothing
  if (!illustrationImageUrl) {
    return null;
  }

  const illustration = (
    <figure css={illustration_container}>
      <img
        src={illustrationImageUrl}
        alt={tt('{{companyName}} Travel booking platform', { companyName })}
        className="image_container"
      />
    </figure>
  );

  // if an action URL is available, wrap in anchor tag and open link in new tab on click
  if (authPageConfig.illustrationActionUrl && !isAppIdLogin) {
    return (
      <a href={authPageConfig.illustrationActionUrl} target="_blank" rel="noopener noreferrer">
        {illustration}
      </a>
    );
  }

  // simply render the image
  return illustration;
};
